import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModelInvoice } from 'src/app/entities/invoices';
import { SezionaliProps } from 'src/app/entities/various';
import { ConfigProps, ConfigServiceService } from 'src/app/services/config-service/config-service.service';
import { SezionaliDisponibiliComponent } from '../dialog/sezionali-disponibili/sezionali-disponibili.component';
import { UTILS } from 'src/app/entities/Utils';
import { ToastService } from 'src/app/services/toast/toast.service';
import { UserData } from 'src/app/services/login/login.service';
import { UserService } from 'src/app/services/users/user.service';
import { InvoicesService } from 'src/app/services/invoices/invoices.service';
import { SharedServiceService } from 'src/app/services/shared/shared-service.service';

@Component({
  selector: 'app-dati-documento',
  templateUrl: './dati-documento.component.html',
  styleUrls: ['./dati-documento.component.css']
})
export class DatiDocumentoComponent implements OnInit { //, OnChanges 
  innerWidth: number | undefined = window.innerWidth;
  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth;
  }

  @Input() model: ModelInvoice | undefined;
  @Output() modelChange = new EventEmitter<ModelInvoice>();
  @Output() selectSelezionale = new EventEmitter<SezionaliProps>();

  @Output() refreshTotali = new EventEmitter<any>();
  @Output() refreshRiepilogo = new EventEmitter<any>();

  @Output() isDestinatarioPresente = new EventEmitter<boolean>();

  //serve per aggiornare le variabili isDestEstero e isMittenteEstero al fine di non usare l'invasivo ngDoCheck
  @Output() validaCedenteCessionario = new EventEmitter<any>();
  //serve per aggiornale le linee "Fake" utili alla validazione
  @Output() aggiornaFakeLinee = new EventEmitter<any>();


  public SezionaliDisponibili: SezionaliProps[] | undefined;
  public sezionaliAbilitati = false;
  public TipoDocumentoSelezionato: string | undefined;
  isLoading: boolean = false;

  public configTabs = {
    selected: 1,
    config: [
      {
        id: 1,
        name: "invoices.edit.documentData.other.tabs.tab1"
      },
      {
        id: 2,
        name: "invoices.edit.documentData.other.tabs.tab2"
      }
    ]
  }

  configProps: ConfigProps | undefined;


  constructor (private configService: ConfigServiceService, 
    private modalService: NgbModal, 
    private toastService: ToastService, 
    private sharedService: SharedServiceService, 
    private userService: UserService) 
  {
    this.innerWidth = window.innerWidth;
  }


  async ngOnInit() {
    this.configProps = new UTILS().deepCopy(await this.configService.getJSON());
    this.configProps!.list.listDivisa.forEach(e => {
      e.label = e.val + " - " + e.label;
    });
    this.configProps!.list.listCausalePagamento.forEach(o => {
      if (o.text!.length > 150) {
        o.text = o.text?.substr(0, 150) + "...";
      }
    })

    //let userInfo = await this.loginService.getSessionUserInfo();
    //this.userInfo = await this.loginService.getSessionUserInfo();
    let userInfo: UserData = JSON.parse(localStorage.getItem("einvuser") || "");
    let response = await this.userService.getSezionali(userInfo!.user_id);
    if (response.success) {
      this.SezionaliDisponibili = response.data as SezionaliProps[];
      this.sezionaliAbilitati = true;
      if (this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero == "") {
        if (this.SezionaliDisponibili.length == 1) {
          this.selectSelezionale.emit(this.SezionaliDisponibili[0]);
          this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero = this.SezionaliDisponibili[0].numerazione + this.SezionaliDisponibili[0].sezionale;
        }
      }

    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.model) {
      this.model = changes.model.currentValue;
      this.TipoDocumentoSelezionato = this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento;
    }
  }

  checkDatiGenerali_BolloVirtuale(event: any) {
    this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiBollo.BolloVirtuale = event.target.checked ? "SI" : '';
    if (this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiBollo.BolloVirtuale != 'SI')
      this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiBollo.ImportoBollo = '';
    else {
      if (this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiBollo.ImportoBollo == '')
        this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.DatiBollo.ImportoBollo = '2.00';
    }
  }
  checkDatiGenerali_Art17(event: any) {
    this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Art73 = event.target.checked ? "SI" : '';
  }


  // Ricerca Indirizzo
  public async sezionaliDisponibili(idTab: number) {
    let modalRef = this.modalService.open(SezionaliDisponibiliComponent, { size: 'lg' });
    modalRef.componentInstance.alreadyLoadedSezionali = this.SezionaliDisponibili;
    let response: SezionaliProps | Array<SezionaliProps> | undefined = await modalRef.result.then(result => { return result; }).catch(err => { return null });
    if (response) {
      if (response instanceof Array && response.length == 0) {
        this.toastService.openToast("Nessun sezionale disponibile", "warning");
        this.sezionaliAbilitati = false;
      } else {
        let obj = response as SezionaliProps;
        this.selectSelezionale.emit(obj);
        this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Numero = obj.numerazione + "" + obj.sezionale;
      }
    }
  }

  // Causali
  public addCausale() {
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale;
    if (list?.filter(l => l == "").length == 0) {
      list.push("");
    } else {
      this.toastService.openToastWithConfig(false, 0, "Compila prima la riga esistente", 'warning');
    }
  }

  public setCausale(index: number, event: any) {
    let list = this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale;
    let val = event.target.value.toUpperCase();
    if (val.length == 0)
      list.splice(index, 1);
    else
      list[index] = event.target.value.toUpperCase();
  }

  public deleteCausale(index: number) {
    let list = this.model?.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Causale;
    list?.splice(index, 1);
  }


  public async notifyChange() {
    await this.modelChange.emit(this.model);
  }


  public verificaDate() {
    var _MS_PER_DAY = 1000 * 60 * 60 * 24;
    //console.log(this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data);

    if (this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data != "") {
      let dataInserita = this.toDate(this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.Data as { year: number; month: number; day: number; });
      var today = new Date();
      var fieldDate = new Date(dataInserita);
      var utc1 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
      var utc2 = Date.UTC(fieldDate.getFullYear(), fieldDate.getMonth(), fieldDate.getDate());
      var differenzaGiorni = (Math.floor((utc2 - utc1) / _MS_PER_DAY));
      if (differenzaGiorni < -12) {
        var message = "FATTURE IMMEDIATE!\n\
          Dal 1 Luglio 2019 sono entrate in vigore le modifiche apportate al DPR 633/72 dal DL 119/2018 e dal Dl 34/2019 (Decreto crescita)\n\
          Le fatture immediate (XML) hanno un tempo massimo consentito pari a 12 giorni.\n\
          Questa fattura ha una data che supera i 12 giorni consentiti.\n\
          Inviandola potrebbe incorrere in sanzioni!\n\
          \n\
          Se questa notifica non la riguarda, basta chiuderla semplicemente!";
        this.toastService.openToastWithConfig(false, 0, message, 'warning');
      } else if (differenzaGiorni > 0) {
        var message = "ATTENZIONE!\n\
          Stai inserendo una fattura con una data successiva a quella odierna.\n\
          Inviandola così verrà scartata!";
        this.toastService.openToastWithConfig(false, 0, message, 'warning');
      }
    }
    // this.getLatestDataInvoice();
  }

  private toDate(date: { year: number, month: number, day: number }) {
    let mese = "";
    let giorno = "";
    mese = (date.month < 10) ? "0" + date.month : (date.month).toString();
    giorno = (date.day < 10) ? "0" + date.day : (date.day).toString();
    return new Date(date.year + "-" + mese + "-" + giorno);
  }


  public checkTipoDocumento(event: any) {
    let arr = ["TD16", "TD17", "TD18", "TD19", "TD20", "TD21", "TD26", "TD27", "TD28"];
    //era già un caso in 17,18,19... ed ora non lo è più
    if (arr.includes(this.TipoDocumentoSelezionato!) && !(arr.includes(event.key))) {
      //console.log("caso 1");
      //ripristino la situazione iniziale. 
      this.ripristinaCedenteCessionario();
      this.validaCedenteCessionario.emit();
      this.TipoDocumentoSelezionato = event.key;
      return;
    }


    if (arr.includes(this.TipoDocumentoSelezionato!) && (arr.includes(event.key))) {
      //console.log("caso 2");
      this.TipoDocumentoSelezionato = event.key;
      return;
    }

    if (!arr.includes(this.TipoDocumentoSelezionato!) && (arr.includes(event.key))) {
      //console.log("caso 3");
      this.sharedService.setDestinatarioPresente(true);
      
      let val = this.model!.FatturaElettronicaBody.DatiGenerali.DatiGeneraliDocumento.TipoDocumento;
      //forzo la copia dei dati da cedente prestatore a cessionario committente.
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici);
      //this.model!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA);
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede);
      this.model!.FatturaElettronicaHeader.DatiTrasmissione.CodiceDestinatario = '2C1PNCW';
      /*this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione);
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.CodEORI = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Cognome = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.CodEORI = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Cognome = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Nome = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Denominazione = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.Titolo = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.DatiAnagrafici!.Anagrafica.PersonaFisica = 0;
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Denominazione = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.IdFiscaleIVA = null;
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.Nome = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.RappresentanteFiscale.PersonaFisica = null;*/
      //se di tipo 17,18,19 e 28 allora devo ripulire i campi del Cedente Prestatore
      if (val == "TD16" || val == "TD17" || val == "TD18" || val == "TD19" || val == "TD28") {
        this.model!.FatturaElettronicaHeader.CedentePrestatore.iban = '';
        /*this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.CAP = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Comune = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Indirizzo = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Nazione = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.NumeroCivico = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione.Provincia = '';*/
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.CAP = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Comune = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Indirizzo = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Nazione = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.NumeroCivico = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede.Provincia = '';
        /*this.model!.FatturaElettronicaHeader.CedentePrestatore.RiferimentoAmministrazione = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.CapitaleSociale = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.NumeroREA = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.SocioUnico = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.StatoLiquidazione = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA.Ufficio = '';*/
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.RegimeFiscale = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.ProvinciaAlbo = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.NumeroIscrizioneAlbo = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdCodice = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.IdFiscaleIVA.IdPaese = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.DataIscrizioneAlbo = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.CodiceFiscale = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.AlboProfessionale = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodEORI = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.CodiceUnivoco = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Cognome = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Denominazione = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Nome = '';
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PEC = undefined;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.PersonaFisica = 0;
        this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici.Anagrafica.Titolo = '';

      }
      this.validaCedenteCessionario.emit();
      this.TipoDocumentoSelezionato = event.key;
    }

  }


  public ripristinaCedenteCessionario() {
    var oldCessionario = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CessionarioCommittente);

    //controllo se si trattava di una autofattura. In tal caso devo ripulire i campi del Cessionario Committente..
    if (this.TipoDocumentoSelezionato! == 'TD21' || this.TipoDocumentoSelezionato! == 'TD26' || this.TipoDocumentoSelezionato! == 'TD27' || this.TipoDocumentoSelezionato! == 'TD28') {
      /*this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione.CAP = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione.Comune = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione.Indirizzo = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione.Nazione = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione.NumeroCivico = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione.Provincia = '';*/
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.CAP = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Comune = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Indirizzo = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Nazione = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.NumeroCivico = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede.Provincia = '';

      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.RegimeFiscale = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.ProvinciaAlbo = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.NumeroIscrizioneAlbo = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdCodice = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.IdFiscaleIVA.IdPaese = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.DataIscrizioneAlbo = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.CodiceFiscale = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.AlboProfessionale = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.CodEORI = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.CodiceUnivoco = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Cognome = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Denominazione = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Nome = '';
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.PEC = undefined;
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.PersonaFisica = 0;
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici.Anagrafica.Titolo = '';


    }
    else {

      this.model!.FatturaElettronicaHeader.CessionarioCommittente.DatiAnagrafici = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici);
      //this.model!.FatturaElettronicaHeader.CessionarioCommittente.IscrizioneREA = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA);
      this.model!.FatturaElettronicaHeader.CessionarioCommittente.Sede = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede);
      //this.model!.FatturaElettronicaHeader.CessionarioCommittente.StabileOrganizzazione = new UTILS().deepCopy(this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione);

    }

    this.model!.FatturaElettronicaHeader.CedentePrestatore.DatiAnagrafici = new UTILS().deepCopy(oldCessionario.DatiAnagrafici);
    //this.model!.FatturaElettronicaHeader.CedentePrestatore.IscrizioneREA = new UTILS().deepCopy(oldCessionario.IscrizioneREA);
    this.model!.FatturaElettronicaHeader.CedentePrestatore.Sede = new UTILS().deepCopy(oldCessionario.Sede);
    //this.model!.FatturaElettronicaHeader.CedentePrestatore.StabileOrganizzazione = new UTILS().deepCopy(oldCessionario.StabileOrganizzazione);

  }




  public async getLatestDataInvoice() {
    this.isLoading = true;
    this.toastService.openToast("Controllo la data con la data dell'ultima fattura", "warning");
    var that = this;
    setTimeout(function () { that.isLoading = false; }, 2000);
    //controllo la data dell'ultima fattura...

  }

}
